import api from '@pray/shared/utils/api';

import type { WarmupAudiencePayload, WarmupAudienceWithMeta } from './types';

export async function addWarmupAudience({
  artistId,
  warmupCampaignId,
  audience,
}: {
  artistId: string;
  warmupCampaignId: string;
  audience: WarmupAudiencePayload;
}): Promise<{ object: WarmupAudienceWithMeta }> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!warmupCampaignId) throw new Error('Warmup campaign ID is required');

  const url = `/web/studio/artists/${artistId}/warmup-campaigns/${warmupCampaignId}/audiences`;
  const response = await api.executePostRequest<{ data: { object: WarmupAudienceWithMeta } }>(url, audience);
  return response.data.data;
}
